import { AssetState } from '@/api/generatedApi';

export const assetStateDisplayText: Partial<Record<AssetState, string>> = {
  indexing: 'Indexing',
  failed: 'Failed to index. Delete and try again.',
  unsupported: 'Failed to index. Asset file format is unsupported.',
  'no-3d-data': 'Failed to index. Asset has no 3D data.',
  'missing-dependencies':
    'Assembly uploaded successfully, but one or more referenced parts are missing. Please upload all dependent files.',
  finished: 'Indexed',
};

export function getAssetStateDisplayText(state: AssetState): string {
  return assetStateDisplayText[state] ?? '';
}

const validAssetStateKeys = new Set<string>(Object.keys(assetStateDisplayText));

export const isValidAssetState = (key: string): key is AssetState => {
  return validAssetStateKeys.has(key);
};
